import { useState, useEffect } from 'react';
const VISIBLE = 'visible';
const EVENT = 'visibilitychange';
export default function usePageVisibility(initialValue = true) {
    const [isVisibile, setIsVisible] = useState(initialValue);
    function handleVisibilityChange() {
        setIsVisible(document.visibilityState === VISIBLE);
    }
    useEffect(() => {
        document.addEventListener(EVENT, handleVisibilityChange);
        return () => document.removeEventListener(EVENT, handleVisibilityChange);
    }, []);
    return isVisibile;
}
